import React from 'react';

const EndConsultationModal = ({ isOpen, onConfirm, onCancel, timeRemaining }) => {
    if (!isOpen) return null;

    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;

    return (
        <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            backdropFilter: 'blur(4px)'
        }}>
            <div className="modal-content" style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '12px',
                maxWidth: '450px',
                width: '90%',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                textAlign: 'center'
            }}>
                <h2 style={{ marginTop: 0, color: '#333' }}>End Consultation?</h2>
                <div style={{ margin: '20px 0', padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '18px' }}>
                        Time remaining: {minutes}:{String(seconds).padStart(2, '0')}
                    </p>
                </div>
                <p style={{ color: '#666', lineHeight: '1.5' }}>
                    Once ended, you cannot continue this consultation.
                    Your performance will be evaluated against SCA criteria and domain marking.
                </p>
                <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '25px' }}>
                    <button
                        onClick={onCancel}
                        style={{
                            padding: '10px 20px',
                            borderRadius: '8px',
                            border: '1px solid #ddd',
                            background: 'white',
                            cursor: 'pointer',
                            fontWeight: '600'
                        }}
                    >
                        Continue Consultation
                    </button>
                    <button
                        onClick={onConfirm}
                        style={{
                            padding: '10px 20px',
                            borderRadius: '8px',
                            border: 'none',
                            background: '#dc3545',
                            color: 'white',
                            cursor: 'pointer',
                            fontWeight: '600'
                        }}
                    >
                        End & Get Feedback
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EndConsultationModal;
